import React from "react";
import Ajax from "../ajax/Ajax";
import { domain } from "../ajax/Ajax";
import { DebounceInput } from "react-debounce-input";
import { Link } from "react-router-dom";

class Searchproduct extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSearchedProducts: false,
      searchStr: "",
      searching: false,
      searchedProducts: [],
    };

    this.makeProductSearch = this.makeProductSearch.bind(this);
  }

  async makeProductSearch(event) {
    if (!event.target.value) {
      this.setState({
        showSearchedProducts: false,
      });

      return;
    }

    let focusObj = this.props.state.focusObj;
    let focus = this.props.state.focus;
    console.log(focus);

    this.setState({
      searchStr: event.target.value,
      searching: true,
    });
    let searchResult = await Ajax.fetchData(
      domain +
        "/en/api/shop/v1/search-stocks/?search=" +
        this.state.searchStr +
        "&focus_id=" +
        focusObj.token +
        "&focus=" +
        focus
    );

    if (searchResult) {
      this.setState({
        searchedProducts: searchResult["data"],
        showSearchedProducts: true,
        searching: false,
      });
    } else {
      this.setState({
        searching: false,
      });
    }
  }

  preventSearchDefault(event) {
    event.preventDefault();
  }

  render() {
    let searching = "";
    if (this.state.searching) {
      console.log("searching now");
      searching = "is-loading";
    }
    return (
      <div className="container">
        <form id="search-store-form" onSubmit={this.preventSearchDefault}>
          <div
            id="search-div"
            className={"control search-div has-icons-left " + searching}
          >
            <DebounceInput
              minLength={2}
              debounceTimeout={500}
              value={this.state.searchStr}
              onChange={this.makeProductSearch}
              className="input"
              type="text"
              placeholder="Search your store"
            />
            <span className="icon is-small is-left">
              <i className="zmdi zmdi-search"></i>
            </span>
          </div>

          <div className="search-submit-btn">
            <button
              onClick={this.makeProductSearch}
              id="search-submit-btn"
              type="button"
              className="button"
            >
              Search
            </button>
          </div>

          {this.state.showSearchedProducts ? (
            <div className="card animated fadeIn searched-container">
              <div
                id="searched-store-products"
                className="has-background-light card"
              >
                <div className="">
                  <table className="table is-hoverable is-stripped is-fullwidth">
                    <tbody>
                      {this.state.searchedProducts.map((product) => (
                        <tr
                          onClick={() => {
                            this.setState({
                              showSearchedProducts: false,
                            });
                          }}
                          className="static-link"
                          key={product.item.id + "_stock"}
                        >
                          <td>{product.item.name}</td>
                          <td>
                            {product.shop.currency}{" "}
                            {product.item.price.toLocaleString()}
                          </td>
                          <td>
                            {" "}
                            {product.item.stock === 0 ? (
                              <span className="has-text-danger">
                                Q. {product.item.stock}
                              </span>
                            ) : (
                              <span>Q. {product.item.stock}</span>
                            )}
                          </td>
                          <td>
                            <div className="d-flex justify-content-between">
                              <div className="mr-2">
                                <Link
                                  to={{
                                    pathname: `/myshop/home/?add=true&pid=${product.item.id}`,
                                    state: {
                                      add: true,
                                      product: product,
                                    },
                                  }}
                                >
                                  <button className="button is-small is-round">
                                    <span className="zmdi zmdi-plus"></span>
                                  </button>
                                </Link>
                              </div>

                              <div className="mr-2">
                                <Link
                                  to={{
                                    pathname:
                                      "/myshop/home/edit-stock/?pid=" +
                                      product.item.id,
                                    state: {
                                      edit: true,
                                      product: product,
                                    },
                                  }}
                                >
                                  <button className="button is-small is-round">
                                    <span className="zmdi zmdi-edit"></span>
                                  </button>
                                </Link>
                              </div>
                              <div className="">
                                <button className="button is-small">
                                  <span className="zmdi zmdi-mail-reply"></span>
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <span></span>
          )}
        </form>
      </div>
    );
  }
}

export default Searchproduct;
